/**
 * CraftLink.Api | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DisabilitySelfIdentificationCA = {
    IChooseNotToRespondToThisQuestion: 'IChooseNotToRespondToThisQuestion',
    Yes: 'Yes',
    No: 'No'
} as const;
export type DisabilitySelfIdentificationCA = typeof DisabilitySelfIdentificationCA[keyof typeof DisabilitySelfIdentificationCA];

